var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nebInfocon",class:_vm.orientation},[_c('div',{staticClass:"nebInfocon-iconWrapper"},[_c('neb-icon',{attrs:{"name":_vm.icon,"height":_vm.iconHeight,"width":_vm.iconWidth,"options":_vm.options}})],1),_c('div',{staticClass:"nebInfocon-infoWrapper"},[_c('p',{staticClass:"nebInfocon-text",style:({
        fontSize: _vm.fontSize
      })},[_vm._v(" "+_vm._s(_vm.info)+" ")])])])}
var staticRenderFns = []

export { render, staticRenderFns }